import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IDroppedFile } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';

type FileType = Pick<IDroppedFile, 'pk' | 'id' | 'errors'>;

@Component({
	selector: 'ongoing-counter',
	templateUrl: './ongoing-counter.component.html',
	styleUrls: ['./ongoing-counter.component.scss'],
	imports: [MatIconModule, MatProgressSpinnerModule],
})
export class OngoingCounterComponent implements OnChanges {
	@Input() filesList: Partial<FileType>[];

	total: number = 0;
	uploaded: number = 0;
	failed: number = 0;
	isLoading = false;

	timeForSuccessTick = signal(false);

	ngOnChanges(changes: SimpleChanges): void {
		const filesList = changes['filesList'].currentValue as FileType[];
		this.total = filesList.length;
		this.uploaded = filesList.filter(file => 'pk' in file || 'id' in file).length;
		this.failed = filesList.filter(
			file => 'errors' in file && Object.keys(file.errors).length
		).length;

		this.isLoading = this.uploaded + this.failed < this.total;

		if (!this.isLoading) {
			this.timeForSuccessTick.set(true);
			setTimeout(() => {
				this.timeForSuccessTick.set(false);
				// this.cdr.detectChanges();
			}, 5000);
		}
	}
}
